import React from 'react';
import { ContactsContextProvider } from '../contexts/ContactsContext';
import Dashboard from '../pages/Dashboard';

const LoggedInLayout = () => {
  return (
    <ContactsContextProvider>
      <Dashboard/>
    </ContactsContextProvider>
  );
};

export default LoggedInLayout;
